
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12 6a7 7 0 100 14 7 7 0 000-14zm-9 7a9 9 0 1118 0 9 9 0 01-18 0z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.832 15.555a1 1 0 00-.277-1.387L13 12.465V10a1 1 0 10-2 0v3a1 1 0 00.445.832l3 2a1 1 0 001.387-.277zM8.75 2.2a1 1 0 011-1h4.5a1 1 0 110 2h-4.5a1 1 0 01-1-1z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11 5V1.5h2V5h-2zM19.707 4.793a1 1 0 010 1.414l-1.5 1.5a1 1 0 11-1.414-1.414l1.5-1.5a1 1 0 011.414 0z","fill":"#fff"}})])
          )
        }
      }
    